// Reveal sections on scroll
(() => {
  const revealTargets = document.querySelectorAll(
    '.hero-copy, .hero-visual, .statement, .tile, .big-tile, .feature-copy, .feature-visual, ' +
    '.lifestyle-head, .life-card, .showcase-copy, .showcase-visual, ' +
    '.kosher-inner, .k-card, .tradein-copy, .tradein-visual, ' +
    '.preorder-copy, .preorder-visual, .faq details, .final-cta h2, .final-cta p, .final-ctas'
  );
  revealTargets.forEach(el => el.classList.add('reveal'));

  const io = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  revealTargets.forEach(el => io.observe(el));
})();

// Case color picker
(() => {
  const cases = document.querySelectorAll('.case');
  cases.forEach(c => {
    c.addEventListener('click', () => {
      cases.forEach(x => x.classList.remove('selected'));
      c.classList.add('selected');
    });
  });
})();

// Mobile nav toggle (legacy .nav-toggle / .nav-links markup)
(() => {
  const toggle = document.querySelector('.nav-toggle');
  const links = document.querySelector('.nav-links');
  if (!toggle || !links) return;
  const setOpen = open => {
    links.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('nav-open', open);
  };
  toggle.addEventListener('click', () => {
    setOpen(!links.classList.contains('open'));
  });
  links.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => setOpen(false));
  });
})();

// Mobile nav toggle — Final build (.hA-burger / .hA-mobile)
(() => {
  const burger = document.querySelector('.hA-burger');
  const panel = document.querySelector('.hA-mobile');
  if (!burger || !panel) return;

  const setOpen = open => {
    if (open) {
      panel.hidden = false;
      // Force reflow so the CSS transition runs from max-height: 0
      void panel.offsetHeight;
      panel.classList.add('is-open');
    } else {
      panel.classList.remove('is-open');
    }
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('hA-nav-open', open);
  };

  burger.addEventListener('click', () => {
    setOpen(burger.getAttribute('aria-expanded') !== 'true');
  });

  // Close after tapping any link
  panel.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', () => setOpen(false));
  });

  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
      burger.focus();
    }
  });

  // Re-hide the panel (and reset state) if the user resizes back up to desktop
  const mq = window.matchMedia('(min-width: 961px)');
  const onChange = () => {
    if (mq.matches) setOpen(false);
  };
  if (mq.addEventListener) mq.addEventListener('change', onChange);
  else mq.addListener(onChange);

  // When the closing transition finishes, fully hide the panel from AT + layout
  panel.addEventListener('transitionend', e => {
    if (e.propertyName === 'max-height' && !panel.classList.contains('is-open')) {
      panel.hidden = true;
    }
  });
})();

// Android 15 software showcase — swap the phone screen based on active app
(() => {
  const apps = document.querySelectorAll('.sw-app');
  const screens = document.querySelectorAll('.screen-app');
  const track = document.querySelector('.software-apps');
  const prev = document.querySelector('.sw-nav-prev');
  const next = document.querySelector('.sw-nav-next');
  if (!apps.length || !screens.length) return;

  const setActive = (key, { scroll = false } = {}) => {
    apps.forEach(b => {
      const on = b.dataset.app === key;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && scroll && track) {
        const li = b.parentElement;
        const liRect = li.getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();
        if (liRect.left < trackRect.left || liRect.right > trackRect.right) {
          track.scrollTo({
            left: li.offsetLeft - (track.clientWidth - li.clientWidth) / 2,
            behavior: 'smooth',
          });
        }
      }
    });
    screens.forEach(s => s.classList.toggle('is-active', s.dataset.app === key));
  };

  apps.forEach(btn => {
    btn.addEventListener('click', () => setActive(btn.dataset.app, { scroll: true }));
  });

  // Slider arrows + dot indicators
  const dots = document.querySelectorAll('.software-dot');
  if (track && (prev || next || dots.length)) {
    const step = () => {
      const tile = track.querySelector('li');
      if (!tile) return 240;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 14;
      return (tile.offsetWidth + gap) * 3;
    };
    const updateNav = () => {
      const max = Math.max(1, track.scrollWidth - track.clientWidth - 1);
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
      if (dots.length) {
        const ratio = Math.min(1, Math.max(0, track.scrollLeft / max));
        const idx = Math.round(ratio * (dots.length - 1));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
    };
    if (prev) prev.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    // Clicking a dot jumps to the corresponding scroll position
    dots.forEach((d, i) => {
      d.addEventListener('click', () => {
        const max = Math.max(1, track.scrollWidth - track.clientWidth - 1);
        const target = (i / (dots.length - 1 || 1)) * max;
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
      d.style.cursor = 'pointer';
    });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }
})();

// ─────────────────────────────────────────────────────────────
// Form feedback — Shopify-aware success / error / loading.
// Powers:
//   · Footer subscribe pill        (.foot-form,  Shopify customer form)
//   · Updates page subscribe pill  (.up-subscribe-form, Shopify customer form)
//   · Contact page form            (.ct-form,   Shopify contact form)
//
// Server-rendered states (Liquid form.posted_successfully? / form.errors)
// remain authoritative. This script adds:
//   · Client-side validation that blocks invalid submissions and surfaces
//     inline field-level errors (instant feedback, no roundtrip).
//   · A loading state on the submit button while Shopify processes.
//   · Smooth scroll + focus on the rendered status banner after redirect.
//   · "Send another message" reset for the contact form success card.
// ─────────────────────────────────────────────────────────────
(() => {
  const SUCCESS_FLAG = 'mfFormSuccess';
  const ICON_CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  const ICON_ALERT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12" y2="16.01"/></svg>';

  // Defer to the browser's native `type="email"` validation when we have the
  // input element handy — it's the same logic Shopify will run server-side and
  // catches the long tail of valid addresses (plus addressing, IDN, +tags…)
  // that a hand-rolled regex tends to reject. Falls back to a permissive
  // regex when only a string is available.
  const EMAIL_FALLBACK_RE =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  const isValidEmail = (v, input) => {
    const trimmed = typeof v === 'string' ? v.trim() : '';
    if (!trimmed) return false;
    if (input && input.type === 'email' && typeof input.checkValidity === 'function') {
      // checkValidity() reflects the input's CURRENT value, including any
      // browser-visible whitespace; require non-empty trimmed value too.
      return input.checkValidity();
    }
    return EMAIL_FALLBACK_RE.test(trimmed);
  };

  const setStatus = (el, kind, msg) => {
    if (!el) return;
    el.classList.remove('form-status--error', 'form-status--success');
    el.classList.add('form-status--' + kind, 'is-visible');
    const icon = kind === 'success' ? ICON_CHECK : ICON_ALERT;
    el.innerHTML =
      '<span class="form-status-icon">' + icon + '</span><span>' + msg + '</span>';
  };

  const clearStatus = el => {
    if (!el) return;
    el.classList.remove('is-visible', 'form-status--error', 'form-status--success');
    el.innerHTML = '';
  };

  const ensureSpinner = button => {
    if (!button) return;
    if (button.querySelector('.submit-spinner')) {
      // Server-rendered already has it. Make sure label exists too.
      if (!button.querySelector('.submit-label')) {
        const label = document.createElement('span');
        label.className = 'submit-label';
        const spinner = button.querySelector('.submit-spinner');
        Array.from(button.childNodes).forEach(node => {
          if (node !== spinner) label.appendChild(node);
        });
        button.insertBefore(label, spinner);
      }
      return;
    }
    const label = document.createElement('span');
    label.className = 'submit-label';
    while (button.firstChild) label.appendChild(button.firstChild);
    button.appendChild(label);
    const sp = document.createElement('span');
    sp.className = 'submit-spinner';
    sp.setAttribute('aria-hidden', 'true');
    button.appendChild(sp);
  };

  const ensureStatus = (form, className, placement) => {
    // Look for a server-rendered status banner first.
    const sibling =
      placement === 'after'
        ? form.parentNode &&
          form.parentNode.querySelector(':scope > .form-status.' + className)
        : form.querySelector(':scope > .form-status.' + className);
    if (sibling) return sibling;
    const el = document.createElement('div');
    el.className = 'form-status ' + className;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    if (placement === 'after') {
      form.parentNode.insertBefore(el, form.nextSibling);
    } else {
      form.appendChild(el);
    }
    return el;
  };

  // ---------- Footer subscribe (.foot-form) ----------
  document.querySelectorAll('form.foot-form').forEach(form => {
    const input = form.querySelector('input[type="email"], input[type="text"]');
    const button = form.querySelector('button[type="submit"], button');
    if (!input || !button) return;
    ensureSpinner(button);
    const status = ensureStatus(form, 'foot-form-status', 'after');

    // Server already rendered an error? Clear it the moment the user types.
    input.addEventListener('input', () => {
      if (form.classList.contains('is-error')) {
        form.classList.remove('is-error');
        clearStatus(status);
      }
    });

    form.addEventListener(
      'submit',
      e => {
        const value = (input.value || '').trim();
        if (!isValidEmail(value, input)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          form.classList.add('is-error');
          setStatus(status, 'error', 'Please enter a valid email address.');
          input.focus();
          return false;
        }
        // Valid — let Shopify handle it. Remember which form was submitted so
        // the post-redirect cleanup below can suppress success on the OTHER
        // customer form (Shopify flags `posted_successfully?` on every
        // customer-form block on the page).
        try { sessionStorage.setItem(SUCCESS_FLAG, form.id || ''); } catch (_) {}
        clearStatus(status);
        form.classList.remove('is-error');
        form.classList.add('is-submitting');
      },
      true
    );
  });

  // ---------- Updates subscribe (.up-subscribe-form) ----------
  document.querySelectorAll('form.up-subscribe-form').forEach(form => {
    const input = form.querySelector('input[type="email"], input');
    const button = form.querySelector('button[type="submit"], button');
    if (!input || !button) return;
    ensureSpinner(button);
    const status = ensureStatus(form, 'up-subscribe-status', 'after');

    input.addEventListener('input', () => {
      if (form.classList.contains('is-error')) {
        form.classList.remove('is-error');
        clearStatus(status);
      }
    });

    form.addEventListener(
      'submit',
      e => {
        const value = (input.value || '').trim();
        if (!isValidEmail(value, input)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          form.classList.add('is-error');
          setStatus(status, 'error', 'Please enter a valid email address.');
          input.focus();
          return false;
        }
        try { sessionStorage.setItem(SUCCESS_FLAG, form.id || ''); } catch (_) {}
        clearStatus(status);
        form.classList.remove('is-error');
        form.classList.add('is-submitting');
      },
      true
    );
  });

  // ---------- Contact form (.ct-form) ----------
  document.querySelectorAll('form.ct-form').forEach(form => {
    const submitBtn = form.querySelector('button[type="submit"], .ct-submit');
    ensureSpinner(submitBtn);

    // Make sure each .ct-field has a .ct-field-error placeholder for client-side
    // messages (server-rendered template already includes them).
    form.querySelectorAll('.ct-field').forEach(field => {
      if (field.querySelector('.ct-field-error')) return;
      const err = document.createElement('p');
      err.className = 'ct-field-error';
      err.setAttribute('aria-live', 'polite');
      field.appendChild(err);
    });

    // Form-level status banner — reuse the server-rendered one if present.
    let status = form.querySelector(':scope > .ct-form-status');
    if (!status) {
      status = document.createElement('div');
      status.className = 'form-status ct-form-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      if (submitBtn && submitBtn.parentNode === form) {
        form.insertBefore(status, submitBtn);
      } else {
        form.appendChild(status);
      }
    }

    const fields = {
      first: form.querySelector('#ct-first'),
      last: form.querySelector('#ct-last'),
      email: form.querySelector('#ct-email'),
      message: form.querySelector('#ct-message'),
    };

    const setFieldError = (input, msg) => {
      if (!input) return;
      const wrap = input.closest('.ct-field');
      if (!wrap) return;
      wrap.classList.toggle('is-error', !!msg);
      const err = wrap.querySelector('.ct-field-error');
      if (err) err.textContent = msg || '';
    };

    const validate = () => {
      let firstInvalid = null;
      const checks = [
        [fields.first, v => (v ? '' : 'Please share your first name.')],
        [fields.last, v => (v ? '' : 'Please share your last name.')],
        [fields.email, v => (isValidEmail(v, fields.email) ? '' : 'Please enter a valid email address.')],
        // Match Shopify's own contact-form rules: just require non-empty content.
        // (Length minimums confused users when Shopify accepted the same input.)
        [fields.message, v => (v ? '' : 'Please add a message before sending.')],
      ];
      checks.forEach(([input, check]) => {
        if (!input) return;
        const msg = check((input.value || '').trim());
        setFieldError(input, msg);
        if (msg && !firstInvalid) firstInvalid = input;
      });
      return firstInvalid;
    };

    Object.values(fields).forEach(input => {
      if (!input) return;
      input.addEventListener('input', () => setFieldError(input, ''));
    });

    // Run validation in the capturing phase so we beat any other listeners
    // (or Shopify's own form-submit machinery) and reliably block bad submits.
    form.addEventListener(
      'submit',
      e => {
        const firstInvalid = validate();
        if (firstInvalid) {
          e.preventDefault();
          e.stopImmediatePropagation();
          setStatus(status, 'error', 'Please fix the highlighted fields and try again.');
          firstInvalid.focus({ preventScroll: false });
          return false;
        }
        // Valid — let Shopify handle it. Show the loading state during submission.
        clearStatus(status);
        form.classList.add('is-submitting');
      },
      true
    );

    // "Send another message" reset on the success card.
    const resetBtn = form.querySelector('.ct-form-success-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        form.classList.remove('is-success');
        form.reset();
        clearStatus(status);
        form.querySelectorAll('.ct-field.is-error').forEach(f => f.classList.remove('is-error'));
        form.querySelectorAll('.ct-field-error').forEach(p => (p.textContent = ''));
        if (fields.first) fields.first.focus();
      });
    }
  });

  // ---------- Post-redirect cleanup for duplicate customer-form success ----------
  // Shopify can't tell which `{% form 'customer' %}` block was actually
  // submitted, so it sets `form.posted_successfully?` on EVERY customer form
  // on the page. The Liquid templates therefore render `.is-success` on both
  // the footer and the updates page newsletter forms. Use the form id we
  // stashed at submit time to keep success on the correct form only.
  let flaggedFormId = '';
  try { flaggedFormId = sessionStorage.getItem(SUCCESS_FLAG) || ''; } catch (_) {}
  const customerForms = document.querySelectorAll(
    'form.foot-form.is-success, form.up-subscribe-form.is-success'
  );
  if (customerForms.length > 1 && flaggedFormId) {
    customerForms.forEach(form => {
      if (form.id !== flaggedFormId) {
        form.classList.remove('is-success');
      }
    });
  }
  // Always clear the flag — it's a one-shot signal for the page render
  // that immediately follows the submit.
  try { sessionStorage.removeItem(SUCCESS_FLAG); } catch (_) {}

  // ---------- Post-redirect: scroll the rendered banner into view ----------
  // Shopify redirects to the same page after a form post; the Liquid template
  // renders a status banner. Bring it into the viewport so the user sees it.
  const renderedStatus = document.querySelector(
    '[data-form-state="success"], [data-form-state="error"]'
  );
  const successCard =
    document.querySelector('.ct-form.is-success .ct-form-success') ||
    document.querySelector('.foot-form.is-success') ||
    document.querySelector('.up-subscribe-form.is-success');
  const target = successCard || renderedStatus;
  if (target) {
    requestAnimationFrame(() => {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (_) {
        target.scrollIntoView();
      }
    });
  }
})();

// Smooth scroll offset for sticky nav
(() => {
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href');
      if (id.length > 1) {
        const target = document.querySelector(id);
        if (target) {
          e.preventDefault();
          const top = target.getBoundingClientRect().top + window.scrollY - 60;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    });
  });
})();
